<template>
  <div>
    <!-- navs -->
    <b-toast
      id="toast-check-modal-calendar-class-teacher-navs"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-check.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-toast
      id="toast-equis-modal-calendar-class-teacher-navs"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-equis.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <!-- end navs -->

    <b-toast
      id="toast-check-modal-request-class-nav"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-check.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-toast
      id="toast-equis-modal-request-class-nav"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-equis.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>

    <b-modal
      :centered="true"
      id="modal-schedule-teacher-nav"
      modal-class="modal-schedule"
      size="lg"
      @hide="handleHideModalTeacher"
      :hide-footer="true"
    >
      <template #modal-header="{ close }">
        <img class="close" src="@/assets/img/close_red.png" @click="close()" />
      </template>
      <div v-if="showEditSchedule" class="card card-img-out">
        <div class="left">
          <img src="@/assets/img/calendar-schedule.png" />
          <h6 class="sub-title text-left">
            <span
              >New Schedule <br />
              Pending</span
            >
          </h6>
        </div>
        <div class="right">
          <span>{{ dataStudent.strFullName }}</span>
        </div>
      </div>
      <div v-if="showEditSchedule" class="ea-alert mt-4 mb-0">
        <icon name="alert-2" />
        <div class="content">
          <p v-if="!isResponseReceived" class="bold mb-4">
            Please respond to the new proposed schedule.
          </p>
          <p v-else class="bold mb-4">
            Schedule counterproposal sent correctly. Awaiting student's
            response.
          </p>
          <div
            class="d-flex justify-content-center"
            style="gap: 5rem"
            v-if="!flagPlanTest"
          >
            <div class="text-left">
              <p class="bold">New recurring schedule:</p>
              <ul class="mb-0" v-if="listRecurrent.length > 0">
                <li v-for="item in listRecurrent" :key="item.date">
                  {{ item.date }}
                </li>
              </ul>
              <p class="mb-0" v-else></p>
            </div>
            <div class="text-left">
              <p class="bold">Add classes on:</p>
              <ul
                class="mb-0"
                v-if="
                  calendarOptions.events.filter((currentValue) => {
                    return currentValue.noRecurrent == true;
                  }).length
                "
              >
                <li
                  v-for="item in calendarOptions.events.filter(
                    (currentValue) => {
                      return currentValue.noRecurrent == true;
                    }
                  )"
                  :key="item.start"
                >
                  {{ getFormatDateCompleteDetail(item.start, item.end) }}
                </li>
              </ul>
              <p class="mb-0" v-else></p>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="edit-schedule-modal">
        <div class="card card-img-out">
          <div class="left">
            <img src="@/assets/img/calendar-schedule.png" />
            <h6 class="sub-title text-left">
              <span
                >New Schedule <br />
                Pending</span
              >
            </h6>
          </div>
          <div class="right">
            <span>{{ dataStudent.strFullName }}</span>
          </div>
        </div>
      </div>
      <b-row>
        <b-col cols="6">
          <div v-if="false" class="content-calendar">
            <p>{{ $t("modals.modalViewSchedule.text.1") }}</p>
            <b-form-datepicker
              :disabled="true"
              v-model="SelectBeginningDate"
              locale="es"
              :hide-header="true"
              direction="right"
              :dropright="true"
              :value-as-date="true"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </div>
        </b-col>
      </b-row>
      <!------------------------modal ----------------------------->
      <div class="calendar" style="position: relative">
        <div v-if="showLoading" class="container-loading">
          <b-spinner :label="$t('reusables.loading')"></b-spinner>
        </div>
        <div v-else>
          <div style="position: absolute; right: 0">
            <div class="d-flex justify-content-center w-100">
              <b-button
                variant="primary"
                v-if="showEditSchedule"
                :disabled="isResponseReceived"
                class="btn-gris"
                :style="'position: relative;bottom: ' + `${0}` + ' ;z-index:10'"
                v-b-modal.modal-schedule-accept-nav
                >{{ $t("modals.modalViewSchedule.button-acept") }}</b-button
              >
              <b-button
                variant="outline-primary"
                v-if="showEditSchedule"
                @click="editCalendarCounterProposal"
                class="ml-2"
                :style="'position: relative;bottom: ' + `${0}` + ' ;z-index:10'"
                ><icon name="edit-pencil" />{{ $t("reusables.edit") }}</b-button
              >
              <b-button
                variant="danger"
                class="ml-2"
                :style="'position: relative;bottom: ' + `${0}` + ' ;z-index:10'"
                @click="reply"
                v-if="!showEditSchedule"
                ><icon name="undo" />{{ $t("horario.reply.text") }}</b-button
              >
              <b-button
                variant="outline-primary"
                v-if="!showEditSchedule"
                :disabled="disabledButton"
                @click="saveChangePrev"
                class="btn-outline ml-2"
                :style="'position: relative;bottom: ' + `${0}` + ' ;z-index:10'"
                ><icon name="edit-pencil" />{{
                  $t("horario.next-class.save-changes")
                }}
              </b-button>
              <b-button
                variant="danger"
                v-if="showEditSchedule"
                :disabled="isResponseReceived"
                class="btn btn-danger ml-2"
                :style="'position: relative;bottom: ' + `${0}` + ' ;z-index:10'"
                v-b-modal.modal-schedule-reject-nav
                >{{ $t("modals.modalViewSchedule.button-reject") }}</b-button
              >
            </div>
          </div>
          <div
            class="body-header edit"
            style="position: absolute; left: 200px; width: 130px"
          >
            <CustomSelect
              v-if="optionsTime.length > 0"
              style="width: 150px"
              class="mb-3"
              @input="idValueSelectEventSelectedTime"
              :options="optionsTime"
              value="value"
              label="text"
              :default="null"
              :defaultValue="this.selectedTime"
              :isActiveMethodValidOpcion="true"
              @change="getWeek()"
            />
          </div>
          <FullCalendar
            class="demo-app-calendar"
            :options="calendarOptions"
            ref="fullCalendar"
          >
            <template v-slot:eventContent="arg">
              <div class="fc-event-main-frame">
                <span
                  v-if="
                    arg.event.startEditable && isFutureEvent(arg.event.start)
                  "
                  @click="removeEvent(arg.event)"
                  style="cursor: pointer"
                  class="material-icons"
                  >clear</span
                >
                <div class="fc-event-time">{{ arg.timeText }}</div>
                <div class="fc-event-title-container">
                  {{ arg.event.title }}
                </div>
              </div>
            </template>
          </FullCalendar>
        </div>
        <!--MODAL ELIMINAR CLASE RECURRENTE-->
        <b-modal
          id="delete-recurring-class-teacher-navs"
          :centered="true"
          body-class="pt-2"
          footer-class="justify-content-center"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
            <h4 class="bold text-center">
              {{
                $t("reusables.student-edited-delete-recurrent-classes-title")
              }}
            </h4>
          </template>
          <div style="font-size: 15px">
            <div class="mx-auto" style="max-width: 300px">
              <p class="d-flex align-items-center mb-2">
                <icon name="calendar" class="mr-2 icon-blue-dark" />
                {{
                  infoEventoDelete.startDate != null &&
                  infoEventoDelete.endDate != null
                    ? getFormatDateCompleteClass(
                        infoEventoDelete.startDate,
                        infoEventoDelete.endDate
                      )
                    : ""
                }}
              </p>
              <p class="d-flex align-items-center mb-2">
                <icon name="time" class="mr-2 icon-blue-dark" />
                {{
                  infoEventoDelete.startDate != null &&
                  infoEventoDelete.endDate != null
                    ? getFormatDateCompleteTitleTime(
                        infoEventoDelete.startDate,
                        infoEventoDelete.endDate
                      )
                    : ""
                }}
              </p>
            </div>
            <div class="mx-auto mt-4" style="max-width: 245px">
              <b-form-radio
                name="some-radios"
                value="true"
                v-model="classDelete.typeClass"
                >{{ $t("reusables.this-class") }}</b-form-radio
              >
              <b-form-radio
                name="some-radios"
                value="false"
                v-model="classDelete.typeClass"
                >{{ $t("reusables.this-class-following") }}</b-form-radio
              >
              <span class="error-input">{{
                validationForm($v.classDelete.typeClass)
              }}</span>
            </div>
          </div>
          <template #modal-footer>
            <b-button
              variant="danger"
              @click="$bvModal.hide('delete-recurring-class-teacher-navs')"
              >{{ $t("reusables.cancel") }}</b-button
            >
            <b-button variant="primary" @click="SaveClassDelete">
              <template v-if="!showSpinnerSend">{{
                $t("reusables.delete")
              }}</template>
            </b-button>
          </template>
        </b-modal>
        <!-- ------- -->
        <!--MODAL AGREGAR CLASE-->
        <b-modal
          id="modal-add-class-teacher-navs"
          :centered="true"
          body-class="pt-2"
          footer-class="justify-content-center"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
            <h4 class="bold text-center">
              {{ $t("reusables.student-edited-add-classes-title") }}
            </h4>
          </template>
          <div style="font-size: 15px">
            <div class="mx-auto" style="max-width: 300px">
              <p class="d-flex align-items-center mb-2">
                <icon name="calendar" class="mr-2 icon-blue-dark" />
                {{
                  this.eventCreated != null
                    ? getFormatDateCompleteClass(
                        this.eventCreated.startStr,
                        this.eventCreated.endStr
                      )
                    : ""
                }}
              </p>
              <p class="d-flex align-items-center mb-2">
                <icon name="time" class="mr-2 icon-blue-dark" />
                {{
                  this.eventCreated != null
                    ? getFormatDateCompleteTitleTime(
                        this.eventCreated.startStr,
                        this.eventCreated.endStr
                      )
                    : ""
                }}
              </p>
            </div>
            <div class="mx-auto mt-4" style="max-width: 245px">
              <b-form-radio
                name="some-radios"
                value="true"
                v-model.trim="classRegister.typeClass"
                >{{ $t("reusables.notRepeated") }}</b-form-radio
              >
              <b-form-radio
                name="some-radios"
                v-model.trim="classRegister.typeClass"
                value="false"
                >{{ $t("reusables.repeats-every-week") }}</b-form-radio
              >
              <span class="error-input">{{
                validationForm($v.classRegister.typeClass)
              }}</span>
            </div>
          </div>
          <template #modal-footer>
            <b-button
              variant="danger"
              @click="$bvModal.hide('modal-add-class-teacher-navs')"
              >{{ $t("reusables.cancel") }}</b-button
            >
            <b-button variant="primary" @click="SaveClassRegister">
              <template v-if="!showSpinnerSend">{{
                $t("reusables.class-add")
              }}</template>
            </b-button>
          </template>
        </b-modal>
        <!-- ------- -->
        <!--MODAL AGREGAR CLASE PLAN PRUEBA-->
        <b-modal
          id="modal-add-event-teacher-navs"
          :title="$t('title.11')"
          :centered="true"
          body-class="pt-2"
          footer-class="justify-content-center"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
            <h5>{{ $t("title.11") }}</h5>
          </template>
          <p class="d-flex align-items-center">
            <i class="material-icons-outlined mr-3">bookmark</i>
            <span>{{ $t("reusables.test-class") }}</span>
          </p>
          <p class="d-flex align-items-center">
            <span class="material-icons-outlined mr-3">schedule</span>
            <span>{{
              this.eventCreated != null
                ? getFormatDate(
                    this.eventCreated.startStr,
                    this.eventCreated.endStr,
                    this.lang,
                    flagPlanTest,
                    maximoHorasCalendario
                  )
                : ""
            }}</span>
          </p>
          <template #modal-footer>
            <b-button
              variant="danger"
              @click="$bvModal.hide('modal-add-event-teacher-navs')"
              >{{ $t("reusables.cancel") }}</b-button
            >
            <b-button variant="primary" @click="saveEvent">
              <template v-if="!showSpinnerSend">{{
                $t("reusables.class-add")
              }}</template>
            </b-button>
          </template>
        </b-modal>
        <!-- ------- -->
        <!--MODAL ELIMINAR CLASE-->
        <b-modal
          id="modal-delete-class-teacher-navs"
          :centered="true"
          body-class="pt-2"
          footer-class="justify-content-center"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
            <h4 class="bold text-center">
              {{ $t("reusables.student-edited-delete-classes-title") }}
            </h4>
          </template>
          <div style="font-size: 15px">
            <div class="mx-auto" style="max-width: 300px">
              <p class="d-flex align-items-center mb-2">
                <icon name="calendar" class="mr-2 icon-blue-dark" />
                {{
                  infoEventoDelete.startDate != null &&
                  infoEventoDelete.endDate != null
                    ? getFormatDateCompleteClass(
                        infoEventoDelete.startDate,
                        infoEventoDelete.endDate
                      )
                    : ""
                }}
              </p>
              <p class="d-flex align-items-center mb-2">
                <icon name="time" class="mr-2 icon-blue-dark" />
                {{
                  infoEventoDelete.startDate != null &&
                  infoEventoDelete.endDate != null
                    ? getFormatDateCompleteTitleTime(
                        infoEventoDelete.startDate,
                        infoEventoDelete.endDate
                      )
                    : ""
                }}
              </p>
            </div>
          </div>
          <template #modal-footer>
            <b-button
              variant="danger"
              @click="$bvModal.hide('modal-delete-class-teacher-navs')"
              >{{ $t("reusables.cancel") }}</b-button
            >
            <b-button variant="primary" @click="SaveClassDeleteNoRecurrent">
              <template v-if="!showSpinnerSend">{{
                $t("reusables.delete")
              }}</template>
            </b-button>
          </template>
        </b-modal>
        <!-- ------- -->
        <!--MODAL ELIMINAR CLASE(SIN RESULTADO)-->
        <b-modal
          id="modal-delete-class-without-result-teacher-navs"
          :centered="true"
          body-class="pt-2"
          footer-class="justify-content-center"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
            <h4 class="bold text-center">
              {{ $t("reusables.student-edited-delete-classes-title") }}
            </h4>
          </template>
          <div style="font-size: 15px">
            <div class="mx-auto" style="max-width: 220px">
              <p class="d-flex align-items-center mb-">
                {{ $t("reusables.there-no-class-eliminate") }}
              </p>
            </div>
          </div>
          <template #modal-footer>
            <b-button
              variant="danger"
              @click="
                $bvModal.hide('modal-delete-class-without-result-teacher-navs')
              "
              >{{ $t("reusables.cancel") }}</b-button
            >
          </template>
        </b-modal>
        <!-- ------- -->
        <!--MODAL VALIDAR CLASE PARA AGREGAR-->
        <b-modal
          id="modal-validate-register-class-teacher-navs"
          :centered="true"
          body-class="pt-2"
          footer-class="justify-content-center"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
          </template>
          <p class="text-center mb-0">
            {{ messageAddClass }}
          </p>
          <template #modal-footer>
            <b-button
              variant="danger"
              @click="
                $bvModal.hide('modal-validate-register-class-teacher-navs')
              "
              >{{ $t("reusables.cancel") }}</b-button
            >
          </template>
        </b-modal>
        <!-- ------- -->
      </div>
    </b-modal>

    <div>
      <!-- ------- -->
      <b-modal id="modal-save-change-counter" :centered="true">
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
        </template>
        <p class="text-center mb-0">
          Do you want to send the modified schedule to
          {{ dataStudent.strFullName }}?
        </p>
        <template #modal-footer>
          <div class="w-100 d-flex justify-content-center">
            <b-button
              variant="danger"
              @click="$bvModal.hide('modal-save-change-counter')"
              >{{ $t("modals.cancel-request.button-cancel") }}</b-button
            >
            <b-button
              @click="saveChangeConfirm"
              class="ml-2"
              variant="primary"
              :class="{ loading: showSpinnerSend }"
            >
              <template v-if="!showSpinnerSend"
                >{{ $t("class-calendar.button.2") }}
              </template>
              <b-spinner
                style="width: 1rem !important; height: 1rem !important"
                v-else
                variant="light"
                label="Spinning"
              ></b-spinner>
            </b-button>
          </div>
        </template>
      </b-modal>
      <b-modal id="modal-save-change-counter-send" :centered="true">
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
        </template>
        <h5 class="bold text-center">Counterproposal sent correctly</h5>
        <p class="text-center mb-0">
          {{ dataStudent.strFullName }} must accept it before it appears on your
          calendar.
        </p>
        <template #modal-footer>
          <div class="w-100 d-flex justify-content-center">
            <b-button
              variant="primary"
              @click="$bvModal.hide('modal-save-change-counter-send')"
              >Understood</b-button
            >
          </div>
        </template>
      </b-modal>

      <b-modal
        id="modal-schedule-accept-nav"
        style="flex-direction: column"
        :centered="true"
        no-close-on-backdrop
        :no-close-on-esc="true"
      >
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
        </template>
        <p class="text-center mb-0">Do you want to accept the new schedule?</p>
        <template #modal-footer>
          <!-- <span>
              <h4 style="text-align: center;">{{$t('modals.modalViewSchedule.modal-schedule.titulo')}} </h4>	
            </span> -->

          <div class="w-100 d-flex justify-content-center">
            <b-button
              variant="danger"
              @click="$bvModal.hide('modal-schedule-accept-nav')"
              >{{
                $t(
                  "modals.modalViewSchedule.modal-schedule-cancel.button-cancel2"
                )
              }}</b-button
            >
            <b-button
              variant="primary"
              @click="acceptProposal"
              class="ml-2"
              :class="{ loading: showSpinnerAccept }"
            >
              <span
                style="color: #ffffff; font-weight: bold"
                v-if="!showSpinnerAccept"
                >{{
                  $t("modals.modalViewSchedule.modal-schedule.text-acept")
                }}</span
              >
              <b-spinner
                style="width: 1rem !important; height: 1rem !important"
                v-else
                variant="light"
                label="Spinning"
              ></b-spinner>
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
    <div>
      <b-modal
        id="modal-validate-save-change-counter-navs-send"
        :centered="true"
        :no-close-on-esc="true"
      >
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
        </template>
        <p class="text-center mb-0">
          {{ message }}
        </p>
        <template #modal-footer>
          <b-button
            variant="primary"
            @click="
              $bvModal.hide('modal-validate-save-change-counter-navs-send'),
                $bvModal.hide('modal-save-change-counter')
            "
          >
            <template v-if="!showSpinnerSend">{{
              $t("reusables.buttonProgramaMasAdelante")
            }}</template>
            <b-spinner
              style="width: 1rem !important; height: 1rem !important"
              v-else
              variant="light"
              label="Spinning"
            ></b-spinner>
          </b-button>
          <b-button variant="danger" @click="saveChangeConfirm">
            {{ $t("reusables.buttonProgramaAhora") }}</b-button
          >
        </template>
      </b-modal>
    </div>
    <div>
      <b-modal
        id="modal-schedule-reject-nav"
        style="flex-direction: column"
        :centered="true"
        no-close-on-backdrop
      >
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
          <!-- <p class="text-center">Do you want to reject {{dataStudent.strFullName}}’s modified schedule? </p>	 -->
        </template>
        <div>
          <span>
            <h6 style="text-align: center" class="sub-title">
              <span class="sub-title-modal"
                >Do you want to reject {{ dataStudent.strFullName }}’s modified
                schedule?</span
              >
            </h6>
            <!-- <br> -->
            <b-form-group id="fieldset-1" class="w-100">
              <b-form-textarea
                v-model.trim="proposal.commentary"
                placeholder="Please enter the motive…"
                rows="3"
                no-resize
                autofocus
                required
                v-bind:class="{ error: $v.proposal.commentary.$error }"
                @blur="$v.proposal.commentary.$touch()"
              >
              </b-form-textarea>
              <span class="error-input">{{
                validationMsgCommetary($v.proposal.commentary)
              }}</span>
            </b-form-group>
          </span>
        </div>
        <template #modal-footer>
          <div class="w-100 d-flex justify-content-center">
            <b-button
              variant="danger"
              @click="$bvModal.hide('modal-schedule-reject-nav')"
              >{{
                $t(
                  "modals.modalViewSchedule.modal-schedule-reject.button-cancel"
                )
              }}</b-button
            >
            <b-button
              variant="primary"
              @click="rejectProposal"
              :disabled="$v.proposal.commentary.$invalid"
              class="ml-2"
              :class="{ loading: showSpinnerReject }"
            >
              <span
                style="color: #ffffff; font-weight: bold"
                v-if="!showSpinnerReject"
                >{{
                  $t("modals.modalViewSchedule.modal-schedule.text-rejectIt")
                }}</span
              >
              <b-spinner
                style="width: 1rem !important; height: 1rem !important"
                v-else
                variant="light"
                label="Spinning"
              ></b-spinner>
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
    <!--MODAL CRUCE CLASES DE PROPUESTA -->
    <div>
      <b-modal
        id="modal-validate-cross-teacher-navs"
        :centered="true"
        body-class="pt-2"
        footer-class="justify-content-center"
      >
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
        </template>
        <p class="text-center mb-0">
          {{ $t("reusables.student-edited-schedule-16") }}
        </p>
        <template #modal-footer>
          <b-button
            variant="danger"
            @click="$bvModal.hide('modal-validate-cross-teacher-navs')"
            >{{ $t("reusables.cancel") }}</b-button
          >
        </template>
      </b-modal>
    </div>
    <!-- ------- -->
    <!-- <videoPerson/> -->
  </div>
</template>
<script>
import "@fullcalendar/core/vdom"; // solves problem with Vite
import CustomSelect from "@/components/form/select";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import * as Constants from "@/assets/js/appConstants";
import { required } from "vuelidate/lib/validators";
import { validationMessage } from "vuelidate-messages";
import {
  getCalendarHeaderFormat,
  getHoursByTimeZoneName,
  getFormatDate,
  convertToUserTimeCalendarEvents,
  getFormatDateCompleteTitle,
  getFormatDateCompleteDetail,
  getFormatDateByDay,
  convertTimeCalendarEvents,
  horarioObtenerNameClaseENConsolidado,
  horarioObtenerColorClaseConsolidado,
  getCalendarHeaderToolbar,
  getCalendarTitle,
  getCalendarEventTimeFormat,
  convertTimeToUTC,
  convertTimeToUserTime,
  convertTimeToUserTimeFormat,
  getFormatDateCompleteClass,
  ValidarMergeHorarios,
  getNextClassTime,
  getFormatDateCompleteTitleTime,
  ValidarMergeHorariosByRecurrent,
} from "@/assets/js/util.js";
const formMessagesCommentary = {
  required: function () {
    return "Required";
  },
  timeOrder: function () {
    return "The start time must be less than the end time";
  },
  crossoverRecurring: function () {
    return `There is crossover with a recurrent class`;
  },
  crossoverNonRecurring: function () {
    return `There is a crossover with a non-recurring class`;
  },
  crossoverClass: function () {
    return "There is a crossover with another event on the list";
  },
  requiredStartTime() {
    return "Start time is required";
  },
  requiredEndTime() {
    return "End time is required";
  },
};
const formUpdateDateMessages = {
  requiredFecha: function () {
    return this.$t("reusables.obligatoryField");
  },
  requiredTypeClass: function () {
    return this.$t("reusables.obligatoryField");
  },
  requiredStartDate: function () {
    return this.$t("reusables.obligatoryField");
  },
};
let eventGuid = 0;
export function createEventId() {
  return String(eventGuid++);
}
export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    CustomSelect,
  },
  data() {
    return {
      groupsPlan: {},
      flagShowHeader: true,
      formatDay: "DD",
      showSpinnerSend: false,
      isResponseReceived: false,
      listCalendar: [],
      listCalendarInit: [],
      listCalendarRecurring: [],
      listCalendarRecurringInit: [],
      formatDateSchedule: "YYYY-MM-DDTHH:mm:ss",
      GroupScheduleCounterProposalId: 0,
      showEditSchedule: true,
      getFormatDate: getFormatDate,
      getFormatDateCompleteTitle: getFormatDateCompleteTitle,
      getFormatDateCompleteDetail: getFormatDateCompleteDetail,
      getFormatDateByDay: getFormatDateByDay,
      getFormatDateCompleteTitleTime: getFormatDateCompleteTitleTime,
      getFormatDateCompleteClass: getFormatDateCompleteClass,
      lang: localStorage.getItem("lang"),
      message: "",
      proposal: {
        commentary: "",
      },
      urlPhoto: Constants.IMAGENES,
      showSpinnerAccept: false,
      showSpinnerReject: false,
      dataStudent: {},
      SelectBeginningDate: new Date(),
      scheduleProposalId: 0,
      showLoading: false,

      showSelectWeek: true,
      uniqDateEnabled: [],
      showLoadingCalendar: false,
      uniqDate: [],
      optionsTime: [],
      selectedTime: null,

      calendarOptions: {
        customButtons: {
          today: {
            text: `${this.$t("reusables.today")}`,
            click: () => {
              this.selectedTime = this.selectTimeInit;
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.gotoDate(new Date());
            },
          },
          prev: {
            text: "PREV",
            click: () => {
              this.selectedTime--;
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.prev();
            },
          },
          next: {
            text: "NEXT",
            click: () => {
              this.selectedTime++;
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.next();
            },
          },
        },
        eventOrder: "start,allDay,className",
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin, // needed for dateClick
        ],
        events: [],
        firstDay: 1,

        //eventColor: "#4285f4",
        eventOverlap: false,
        themeSystem: "bootstrap",
        nowIndicator: true,
        headerToolbar: getCalendarHeaderToolbar(this.flagShowHeader),
        titleFormat: function (date) {
          return getCalendarTitle(date.date, this.lang);
        },
        height: "auto",
        allDaySlot: false,
        viewDidMount: (view) => {
          let GMT = getHoursByTimeZoneName(
            this.$moment,
            this.$store.state.user.timeZoneName
          );
          view.el.querySelector(".fc-timegrid-axis-frame").innerHTML = GMT;
        },
        initialView: "timeGridWeek",
        dayHeaderContent: (args) => {
          return getCalendarHeaderFormat(
            this.$moment,
            args.date,
            this.lang,
            this.formatDay
          );
        },
        eventTimeFormat: getCalendarEventTimeFormat(),
        initialEvents: [], //INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        editable: true,
        scrollTimeReset: false,
        eventColor: Constants.CALENDAR_STATUS.CONFIRM.COLOR,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        eventResizableFromStart: false,
        select: this.handleDateSelect,
        selectAllow: this.handleSelecAllow,
        eventChange: this.handleEvents,
      },
      listRecurrent: [],
      ARRAY_DIA_SEMANA: Constants.DIA_SEMANA,
      horarioObtenerNameClaseENConsolidado:
        horarioObtenerNameClaseENConsolidado,
      TYPE_SCHEDULE: Constants.TYPE_SCHEDULE,
      arrayCalendarInit: [],
      eventCreated: null,
      optionsClassDelete: [],
      optionsClassRegister: [],
      infoEventoDelete: {
        startDate: null,
        endDate: null,
      },
      infoEventoRegister: {
        startDate: null,
        endDate: null,
      },
      classRegister: {
        id: "",
        typeClass: null,
        timeClass: null,
        startDate: null,
        endDate: null,
      },
      classDelete: {
        id: 0,
        typeClass: null,
        timeClass: null,
        startDate: null,
        endDate: null,
        isDelete: false,
      },
      eventDelete: null,
      eventRegister: null,
      listClassDelete: [],
      listClassRegister: [],
      classDeleteTimeClass: " ",
      minDate: null,
      maxDate: null,
      messageAddClass: "",
      arrayCalendarChange: [],
      maximoHorasCalendario: 0,
      flagPlanTest: false,
      daysMaxSchedule: 0,
    };
  },
  validations: {
    proposal: {
      commentary: {
        required,
      },
    },
    classRegister: {
      typeClass: {
        requiredTypeClass(value) {
          return !(value === "" || value == null);
        },
      },
    },
    classDelete: {
      typeClass: {
        requiredTypeClass(value) {
          return !(value === "" || value == null);
        },
      },
    },
  },
  computed: {
    disabledButton() {
      let p_total = this.calendarOptions.events.filter((currentValue) => {
        return currentValue.editable;
      }).length;
      if (p_total == 0) {
        return true;
      }
      let elmts = [];
      let arrayCalendar = [];
      let arrayCalendarInit = [];
      let arraySend = this.listCalendar.filter((currentValue) => {
        return currentValue.request;
      });
      let arraySendInit = this.arrayCalendarInit.filter((currentValue) => {
        return currentValue.request;
      });

      arraySend.forEach((element) => {
        arrayCalendar.push(
          `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
        );
      });
      arraySendInit.forEach((element) => {
        arrayCalendarInit.push(
          `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
        );
      });
      if (
        this.listClassDelete.filter(
          (item) =>
            item.id > 0 && (item.isNew === undefined || item.isNew === false)
        ).length > 0
      ) {
        return false;
      } else {
        if (arrayCalendar.length > arrayCalendarInit.length) {
          elmts = arrayCalendar.filter(function (i) {
            return this.indexOf(i) < 0;
          }, arrayCalendarInit);
        } else {
          elmts = arrayCalendarInit.filter(function (i) {
            return this.indexOf(i) < 0;
          }, arrayCalendar);
        }
        if (arraySend.length == 0) {
          return true;
        } else {
          return elmts.length == 0 ? true : false;
        }
      }
    },
  },
  methods: {
    isFutureEvent(start) {
      const now = this.$moment();
      return this.$moment(start).isAfter(now);
    },
    validationForm: validationMessage(formUpdateDateMessages),
    validationMsgCommetary: validationMessage(formMessagesCommentary),
    getWeek() {
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.gotoDate(this.uniqDate[this.selectedTime]);
    },
    idValueSelectEventSelectedTimeClassRegister(event) {
      if (event != null) {
        this.classRegister.id = 0;
        this.classRegister.startDate = event.startStr;
        this.classRegister.endDate = event.endStr;
        this.classRegister.noRecurrent = true;
        this.classRegister.stateClassId = parseInt(
          Constants.CALENDAR_STATUS.CONFIRM.VALUE
        );
        this.classRegister.isNew = true;
      }
    },
    idValueSelectEventSelectedTimeClassDelete(event) {
      if (event != null) {
        this.classDelete.startDate = event.start;
        this.classDelete.endDate = event.end;
        this.classDelete.isDelete = true;
        this.classDelete.stateClassId = parseInt(
          Constants.CALENDAR_STATUS.CONFIRM.VALUE
        );
      }
    },
    getDateMinMax(minDateArray) {
      this.minDate = new Date(minDateArray);

      let d = new Date(minDateArray),
        diff = d.getDate() + 7; //TODO:Validar param
      this.maxDate = new Date(d.setDate(diff));
    },
    ValidateBetweenClasses(event1, event2) {
      const start1 = new Date(
        `${event1.start.split("T")[0]}T${event1.classStartTimeStr}`
      );
      const end1 = new Date(
        `${event1.start.split("T")[0]}T${event1.classEndTimeStr}`
      );
      const start2 = new Date(event2.start);
      const end2 = new Date(event2.end);

      return start1 < end2 && start2 < end1;
    },
    ValidateLists(event, list) {
      for (let otherEvent of list) {
        if (
          event !== otherEvent &&
          this.ValidateBetweenClasses(event, otherEvent)
        ) {
          return false;
        }
      }
      return true;
    },
    ValidateBetweenLists(event, listCalendarRecurring) {
      const dayOfWeek = new Date(event.start).getDay();

      for (let recurringEvent of listCalendarRecurring) {
        const recurringDayOfWeek = new Date(recurringEvent.start).getDay();

        if (dayOfWeek === recurringDayOfWeek) {
          const recurringStartDate = new Date(event.start);
          recurringStartDate.setHours(
            new Date(recurringEvent.start).getHours()
          );
          recurringStartDate.setMinutes(
            new Date(recurringEvent.start).getMinutes()
          );

          const recurringEndDate = new Date(event.start);
          recurringEndDate.setHours(new Date(recurringEvent.end).getHours());
          recurringEndDate.setMinutes(
            new Date(recurringEvent.end).getMinutes()
          );

          const adjustedRecurringEvent = {
            start: recurringStartDate.toISOString(),
            end: recurringEndDate.toISOString(),
          };

          if (this.ValidateBetweenClasses(event, adjustedRecurringEvent)) {
            return false;
          }
        }
      }
      return true;
    },
    removeClass(index) {
      this.listCalendar.splice(index, 1);
    },
    handleInput() {
      this.$v.listCalendar.$touch();
      this.$v.listCalendarRecurring.$touch();
    },
    formatDateMMDDYYYY(date) {
      return this.$moment(date).format("MM/DD/YYYY");
    },
    async handleHideModalTeacher() {
      document.body.style.overflow = "";
      this.$nextTick(() => {
      document.body.classList.remove("modal-open"); 
      document.documentElement.classList.remove("modal-open");
      document.querySelector(".content-main")?.classList.remove("hide-background"); 
      document.querySelector(".content-main")?.classList.remove("push-down");
      });      
      await this.getTotalDetailByTeacher();
    },
    async getTotalDetailByTeacher() {
      let data = {
        tearcherid: this.$store.state.user.personTeacherId,
      };
      await baseInstanceAxios
        .get(
          `${this.apiURL}/resources/PersonsStudents/StudensTotalDetailByTeacher`,
          {
            params: data,
          }
        )
        .then((response) => {
          if (this.$store.state.user != null) {
            const updatedUser = {
              ...this.$store.state.user,
              totalDetail: response.data,
            };
            this.$store.commit("mutateUser", updatedUser);
          }
        });
      this.$bvModal.hide("modal-schedule-accept-nav");
      this.$bvModal.hide("modal-schedule-teacher-nav");
    },
    acceptProposal() {
      this.showSpinnerAccept = true;
      let data = {
        scheduleEditedId: this.scheduleProposalId,
        Usuario: this.$store.state.user.email,
        FlagStudent: false,
      };

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupsCoursesLessons/SaveScheduleEditedStudentSteachersDetails`,
          {
            params: data,
          }
        )
        .then((response) => {
          let value = response.data.value;
          this.showSpinnerAccept = false;
          if (value == -3) {
            this.$bvModal.hide("modal-schedule-accept-nav");
            this.message =
              "Was found conflicts with your current availability.";
            this.$bvToast.show("toast-equis-modal-request-class-nav");
          } else if (value == -2) {
            this.$bvModal.hide("modal-schedule-accept-nav");
            this.message =
              "The student has deleted or modified the schedule change request. Please check again in a few moments.";
            this.$bvToast.show("toast-equis-modal-request-class-nav");
          } else if (value > 0) {
            this.message = this.$t("modalConfirm.text.3");
            this.$bvToast.show("toast-check-modal-request-class-nav");
            this.showSpinnerAccept = false;
            this.$bvModal.hide("modal-schedule-accept-nav");
            this.$bvModal.hide("modal-schedule-teacher-nav");
            this.$emit("update-schedule");
          }
        })
        .catch((error) => {
          this.message = this.$t("modalConfirm.text.6");
          this.$bvToast.show("toast-equis-modal-request-class-nav");
          this.showSpinnerAccept = false;
        });
    },
    rejectProposal() {
      this.showSpinnerReject = true;
      let data = {
        GroupScheduleProposalId: this.scheduleProposalId,
        RejectCommentary: this.proposal.commentary,
        UserMail: this.$store.state.user.email,
        FlagStudent: false,
      };

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupScheduleCounterProposal/RejectEditionScheduleByTeacher`,
          {
            params: data,
          }
        )
        .then((response) => {
          this.message = this.$t("modalConfirm.text.7");
          this.$bvToast.show("toast-check-modal-request-class-nav");
          this.showSpinnerReject = false;
          this.$bvModal.hide("modal-schedule-reject-nav");
          this.$bvModal.hide("modal-schedule-teacher-nav");
          //this.$emit('update-schedule')
          this.proposal.commentary = "";
        })
        .catch((error) => {
          this.message = this.$t("modalConfirm.text.8");
          this.$bvToast.show("toast-equis-modal-request-class-nav");
          this.showSpinnerReject = false;
        });
    },
    getShowCalendar(scheduleProposalId, dataStudent) {
      this.scheduleProposalId = scheduleProposalId;
      this.dataStudent = dataStudent;
      this.SelectBeginningDate = dataStudent.beginningDate;

      this.calendarOptions.selectable = false;
      this.getList();
    },

    getList() {
      this.showLoading = true;

      let data = {
        PersonTeacherId: this.$store.state.user.personTeacherId,
        GroupScheduleProposalId: this.scheduleProposalId,
        TimeZoneName: this.$store.state.user.timeZoneName,
      };

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupScheduleCounterProposal/GetEditionScheduleAndCounterByStudent`,
          {
            params: data,
          }
        )
        .then((response) => {
          if (response.data.entity) {
            this.isResponseReceived = response.data.entity.isResponseReceived;
            this.GroupScheduleCounterProposalId =
              response.data.entity.groupScheduleCounterProposalId;
            const pBeginningDate =
              response.data.entity != null
                ? convertTimeToUserTime(
                    response.data.entity.detailFirst,
                    this.$store.state.user.timeZoneName,
                    this.$moment
                  )
                : null;
            let arrayHours = response.data.entity.listScheduleCounterDetails;
            let dataList = [];
            let arrayInitWeek = [];
            let arrayEnabledDate = [];
            this.groupsPlan = {};
            this.groupsPlan = response.data.entity.groupPlan;
            this.maximoHorasCalendario = 0;
            this.flagPlanTest = false;
            this.daysMaxSchedule = 0;
            if (response.data.entity.planDetails) {
              let planDetails = response.data.entity.planDetails;
              this.flagPlanTest = planDetails.flagPlanTest;
              this.flagShowHeader = true;
            }
            arrayHours.forEach((element) => {
              let startOfWeek = this.$moment(element.startDate)
                .startOf("week")
                .toDate();
              let endOfWeek = this.$moment(element.startDate)
                .endOf("week")
                .toDate();

              let month =
                parseInt(startOfWeek.getMonth()) + 1 < 10
                  ? `0${parseInt(startOfWeek.getMonth()) + 1}`
                  : parseInt(startOfWeek.getMonth()) + 1;
              let dayDate =
                parseInt(startOfWeek.getDate()) < 10
                  ? `0${parseInt(startOfWeek.getDate())}`
                  : parseInt(parseInt(startOfWeek.getDate()));

              let monthEnd =
                parseInt(endOfWeek.getMonth()) + 1 < 10
                  ? `0${parseInt(endOfWeek.getMonth()) + 1}`
                  : parseInt(endOfWeek.getMonth()) + 1;
              let dayDateEnd =
                parseInt(endOfWeek.getDate()) + 1 < 10
                  ? `0${parseInt(endOfWeek.getDate()) + 1}`
                  : parseInt(parseInt(endOfWeek.getDate()) + 1);

              arrayInitWeek.push(
                startOfWeek.getFullYear() + "-" + month + "-" + dayDate
              );

              arrayEnabledDate.push(
                startOfWeek.getFullYear() + "-" + month + "-" + dayDate
              );
              arrayEnabledDate.push(
                endOfWeek.getFullYear() + "-" + monthEnd + "-" + dayDateEnd
              );
              if (element.stateClass) {
                element.stateClass.name = horarioObtenerNameClaseENConsolidado(
                  element.stateClass.strValue
                );
              }

              let jsonData = {
                id: createEventId(),
                description: "",
                idx: element.id,
                start: element.startDate,
                end:
                  this.$moment(element.endDate).format("mm") == "59"
                    ? this.$moment(element.endDate)
                        .add(1, "minutes")
                        .format("YYYY-MM-DDTHH:mm:ss")
                    : element.endDate,
                title:
                  element.typeOfSchedule == Constants.TYPE_SCHEDULE.TEACHER
                    ? this.$t("reusables.unavailable")
                    : element.className +
                        (element.flagPlanTest
                          ? " | " + this.$t("reusables.test-class")
                          : "") || this.$t("reusables.class"),
                color:
                  element.typeOfSchedule == Constants.TYPE_SCHEDULE.TEACHER
                    ? Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR
                    : element.flagUpdate
                    ? element.noRecurrent
                      ? Constants.CALENDAR_STATUS_ADDITIONAL_COLOR.NORECURRENT
                      : Constants.CALENDAR_STATUS.CONFIRM.COLOR
                    : horarioObtenerColorClaseConsolidado(
                        element.stateClass.strValue
                      ),
                editable: false,
                editableSchedule: element.flagUpdate,
                noRecurrent: element.noRecurrent,
                isNew: element.isNew,
                date: this.formatDateMMDDYYYY(element.startDate),
                classStartTimeStr: this.$moment(
                  this.$moment(element.startDate)
                ).format("HH:mm:ss"),
                classEndTimeStr: this.$moment(
                  this.$moment(element.endDate)
                ).format("HH:mm:ss"),
              };

              dataList.push(jsonData);
            });

            this.calendarOptions.events = dataList;
            var listNoRecurrent = dataList.filter((currentValue) => {
              return (
                currentValue.editableSchedule &&
                currentValue.noRecurrent == true
              );
            });
            this.listCalendar = JSON.parse(JSON.stringify(listNoRecurrent));
            this.listCalendarInit = JSON.parse(JSON.stringify(listNoRecurrent));
            var listRecurrent = dataList.filter((currentValue) => {
              return (
                currentValue.editableSchedule &&
                currentValue.noRecurrent == false
              );
            });

            this.listCalendarRecurring = JSON.parse(
              JSON.stringify(listRecurrent)
            );
            this.listCalendarRecurringInit = JSON.parse(
              JSON.stringify(listRecurrent)
            );

            this.optionsTime = [];
            this.uniqDateEnabled = [...new Set(arrayEnabledDate)];
            let endDateParam = this.$moment(
              this.groupsPlan.expirationDate
            ).format("YYYY-MM-DD");
            let endDate = this.$moment(this.groupsPlan.expirationDate)
              .add(1, "day")
              .endOf("day")
              .format("YYYY-MM-DD");

            if (this.uniqDateEnabled.length > 1) {
              let startDate = this.$moment(new Date()).format("YYYY-MM-DD");
              if (
                !this.$moment(endDate, "YYYY-MM-DD", true).isValid() ||
                this.$moment(endDate).isBefore(startDate)
              ) {
                endDate = startDate;
              }
              this.calendarOptions.validRange = {
                start: startDate,
                end: endDate,
              };
            }

            let startOfWeekCurrent =
              this.$moment(pBeginningDate).startOf("week");
            let endOfWeekFinal = this.$moment(endDateParam).endOf("week");
            this.uniqDate = [];
            let countSelect = 0;
            let countValited = 0;
            let weekIndex = 0;
            while (startOfWeekCurrent.isSameOrBefore(endOfWeekFinal)) {
              let startOfWeekFormatted =
                startOfWeekCurrent.format("YYYY-MM-DD");
              this.uniqDate.push(startOfWeekFormatted);
              let isBeforeCurrentWeek = startOfWeekCurrent.isBefore(
                this.$moment().startOf("week"),
                "day"
              );
              if (
                startOfWeekCurrent.isSame(this.$moment().startOf("week"), "day")
              ) {
                countSelect = weekIndex;
                countValited++;
              }

              this.optionsTime.push({
                value: weekIndex,
                text: this.$t("reusables.week") + ` ${weekIndex + 1}`,
                disabled: isBeforeCurrentWeek,
              });

              startOfWeekCurrent.add(1, "week");
              weekIndex++;
            }
            if (this.uniqDate.length > 0) {
              this.selectedTime = countSelect;
              this.selectTimeInit = countSelect;
            }
            if (countValited == 0) {
              this.selectedTime = this.uniqDate.length - 1;
              this.selectTimeInit = this.uniqDate.length - 1;
            }
          }
          this.calendarOptions.headerToolbar = getCalendarHeaderToolbar(
            this.flagShowHeader
          );
          this.formatDay = "DD";
          this.listRecurrent = [];
          this.listRecurrent = this.groupedEvents();
          this.showLoading = false;
          this.showEditSchedule = true;
        });
    },
    groupedEvents() {
      let grouped = {};
      let pListRecurrent = this.calendarOptions.events.filter(
        (currentValue) => {
          return (
            currentValue.editableSchedule && !(currentValue.noRecurrent == true)
          );
        }
      );
      pListRecurrent.forEach((event) => {
        const formattedDate = this.getFormatDateCompleteTitle(
          event.start,
          event.end
        );
        if (!grouped[formattedDate]) {
          grouped[formattedDate] = [];
        }
        grouped[formattedDate].push(event);
      });
      const dayOrder =
        localStorage.getItem("lang") == "es"
          ? this.ARRAY_DIA_SEMANA.ES
          : this.ARRAY_DIA_SEMANA.EN;

      const dayOrderIndex = dayOrder.reduce((acc, day, index) => {
        acc[day] = index;
        return acc;
      }, {});

      return Object.keys(grouped)
        .map((date) => {
          const dayName = date.split(",")[0];
          const timeRange = date.split(",")[1].trim();
          return {
            date: date,
            events: grouped[date],
            dayOrder: dayOrderIndex[dayName],
            timeRange: timeRange,
          };
        })
        .sort((a, b) => {
          if (a.dayOrder !== b.dayOrder) {
            return a.dayOrder - b.dayOrder;
          }
          return a.timeRange.localeCompare(
            b.timeRange,
            localStorage.getItem("lang") === "es" ? "es" : "en"
          );
        })
        .map((group) => {
          return {
            date: group.date,
            events: group.events,
          };
        });
    },
    handleDateClick: function (arg) {
      alert("date click! " + arg.dateStr);
    },
    //Edición de Horario
    reply() {
      this.getList();
    },
    editCalendarCounterProposal() {
      this.showLoading = true;
      this.formatDay = "";
      this.calendarOptions.selectable = true;

      this.hideButtonsForEdit = true;
      this.formatDay = "";
      if (this.flagPlanTest) {
        this.formatDay = "DD";
      }
      let data = {
        PersonTeacherId: this.$store.state.user.personTeacherId,
        GroupScheduleProposalId: this.scheduleProposalId,
        TimeZoneName: this.$store.state.user.timeZoneName,
      };

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupScheduleCounterProposal/GetEditionScheduleAndCounterByStudent`,
          {
            params: data,
          }
        )
        .then((response) => {
          if (
            response.data.entity != null &&
            response.data.entity.listScheduleCounterDetails.length == 0
          ) {
            this.$bvModal.show("modal-not-edit");
          } else {
            // this.SelectBeginningDateEdit = "";
            this.listClassRegister = [];
            this.listCalendar = [];
            this.arrayCalendarInit = [];
            this.calendarOptions.events = [];
            const pBeginningDate =
              response.data.entity != null
                ? convertTimeToUserTime(
                    response.data.entity.detailFirst,
                    this.$store.state.user.timeZoneName,
                    this.$moment
                  )
                : null;

            this.listClassDelete = [];

            if (response.data.entity.planDetails) {
              let planDetails = response.data.entity.planDetails;
              this.maximoHorasCalendario = planDetails.maximoHorasCalendario;
              this.flagPlanTest = planDetails.flagPlanTest;
              this.daysMaxSchedule = planDetails.daysMaxSchedule + 1;
              this.flagShowHeader = true;
              if (planDetails.flagPlanTest) {
                this.flagShowHeader = true;
                this.maximoHorasCalendario = planDetails.durationClassTest / 60;
              }
            }
            this.flagEdit = true;
            this.calendarOptions.selectable = true;
            this.showSelectWeek = false;
            let arrayList = response.data.entity.listScheduleCounterDetails;
            this.calendarOptions.headerToolbar = getCalendarHeaderToolbar(
              this.flagShowHeader
            );
            let arrayInitWeek = [];
            let arrayEnabledDate = [];
            let scheduleTotal = [];
            arrayList.forEach((element) => {
              let startOfWeek = this.$moment(element.startDate)
                .startOf("week")
                .toDate();
              let endOfWeek = this.$moment(element.startDate)
                .endOf("week")
                .toDate();

              let month =
                parseInt(startOfWeek.getMonth()) + 1 < 10
                  ? `0${parseInt(startOfWeek.getMonth()) + 1}`
                  : parseInt(startOfWeek.getMonth()) + 1;
              let dayDate =
                parseInt(startOfWeek.getDate()) < 10
                  ? `0${parseInt(startOfWeek.getDate())}`
                  : parseInt(parseInt(startOfWeek.getDate()));

              let monthEnd =
                parseInt(endOfWeek.getMonth()) + 1 < 10
                  ? `0${parseInt(endOfWeek.getMonth()) + 1}`
                  : parseInt(endOfWeek.getMonth()) + 1;
              let dayDateEnd =
                parseInt(endOfWeek.getDate()) + 1 < 10
                  ? `0${parseInt(endOfWeek.getDate()) + 1}`
                  : parseInt(parseInt(endOfWeek.getDate()) + 1);

              arrayInitWeek.push(
                startOfWeek.getFullYear() + "-" + month + "-" + dayDate
              );

              arrayEnabledDate.push(
                startOfWeek.getFullYear() + "-" + month + "-" + dayDate
              );
              arrayEnabledDate.push(
                endOfWeek.getFullYear() + "-" + monthEnd + "-" + dayDateEnd
              );
              var _id = createEventId();

              let jsonData = {
                id: _id,
                description: "",
                idx: element.id,
                start: element.startDate,
                end:
                  this.$moment(element.endDate).format("mm") == "59"
                    ? this.$moment(element.endDate)
                        .add(1, "minutes")
                        .format("YYYY-MM-DDTHH:mm:ss")
                    : element.endDate,
                title:
                  element.typeOfSchedule == Constants.TYPE_SCHEDULE.TEACHER
                    ? this.$t("reusables.unavailable")
                    : element.className +
                        (element.flagPlanTest
                          ? " | " + this.$t("reusables.test-class")
                          : "") || this.$t("reusables.class"),
                color:
                  element.typeOfSchedule == Constants.TYPE_SCHEDULE.TEACHER
                    ? Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR
                    : element.flagUpdate
                    ? element.noRecurrent
                      ? Constants.CALENDAR_STATUS_ADDITIONAL_COLOR.NORECURRENT
                      : Constants.CALENDAR_STATUS.CONFIRM.COLOR
                    : horarioObtenerColorClaseConsolidado(
                        element.stateClass.strValue
                      ),
                editable: element.flagUpdate,
                request: element.flagUpdate,
                editableSchedule: element.flagUpdate,
                noRecurrent: element.noRecurrent,
                isNew: element.isNew,
                idDetalle: element.scheduleEditId,
              };

              let data = {
                id: element.id,
                idx: jsonData.id,
                StartDate: element.startDate,
                EndDate: element.endDate,
                editable: element.flagUpdate,
                request: element.flagUpdate,
                noRecurrent: element.noRecurrent,
                isNew: element.isNew,
                idDetalle: element.scheduleEditId,
              };

              let dataInit = {
                id: element.id,
                idx: jsonData.id,
                StartDate: element.startDate,
                EndDate: element.endDate,
                editable: element.flagUpdate,
                request: element.flagUpdate,
                noRecurrent: element.noRecurrent,
                isNew: element.isNew,
                idDetalle: element.scheduleEditId,
              };
              this.listCalendar.push(data);
              this.arrayCalendarInit.push(dataInit);
              this.calendarOptions.events.push(jsonData);
              scheduleTotal.push(data);

              if (element.noRecurrent) {
                var idEvent = this.calendarOptions.events.find(
                  (item) => item.idDetalle == element.scheduleEditId
                );
                let objRecurrent = {
                  idx: idEvent != undefined ? idEvent.id : -1,
                  id: element.startDate + "|" + element.endDate,
                  typeClass: "true",
                  timeClass: null,
                  startDate: element.startDate,
                  endDate: element.endDate,
                  isNew: element.isNew,
                };
                this.listClassRegister.push(objRecurrent);
              }
            });
            this.formatDay = "DD";
            this.optionsTime = [];
            this.uniqDateEnabled = [...new Set(arrayEnabledDate)];
            let endDateParam = this.$moment(
              this.groupsPlan.expirationDate
            ).format("YYYY-MM-DD");
            let endDate = this.$moment(this.groupsPlan.expirationDate)
              .add(1, "day")
              .endOf("day")
              .format("YYYY-MM-DD");

            if (this.uniqDateEnabled.length > 1) {
              let startDate = this.$moment(new Date()).format("YYYY-MM-DD");
              if (
                !this.$moment(endDate, "YYYY-MM-DD", true).isValid() ||
                this.$moment(endDate).isBefore(startDate)
              ) {
                endDate = startDate;
              }
              this.calendarOptions.validRange = {
                start: startDate,
                end: endDate,
              };
            }
            let startOfWeekCurrent =
              this.$moment(pBeginningDate).startOf("week");
            let endOfWeekFinal = this.$moment(endDateParam).endOf("week");
            this.uniqDate = [];
            let countSelect = 0;
            let countValited = 0;
            let weekIndex = 0;
            while (startOfWeekCurrent.isSameOrBefore(endOfWeekFinal)) {
              let startOfWeekFormatted =
                startOfWeekCurrent.format("YYYY-MM-DD");
              this.uniqDate.push(startOfWeekFormatted);
              let isBeforeCurrentWeek = startOfWeekCurrent.isBefore(
                this.$moment().startOf("week"),
                "day"
              );
              if (
                startOfWeekCurrent.isSame(this.$moment().startOf("week"), "day")
              ) {
                countSelect = weekIndex;
                countValited++;
              }

              this.optionsTime.push({
                value: weekIndex,
                text: this.$t("reusables.week") + ` ${weekIndex + 1}`,
                disabled: isBeforeCurrentWeek,
              });

              startOfWeekCurrent.add(1, "week");
              weekIndex++;
            }

            if (this.uniqDate.length > 0) {
              this.selectedTime = countSelect;
              this.selectTimeInit = countSelect;
            }

            if (countValited == 0) {
              this.selectedTime = this.uniqDate.length - 1;
              this.selectTimeInit = this.uniqDate.length - 1;
            }
            setTimeout(() => {
              if (this.listCalendar.length > 0) {
                let calendarApi = this.$refs.fullCalendar.getApi();
                calendarApi.gotoDate(new Date());
              }
            }, 500);
            this.showEditSchedule = false;
            this.showLoading = false;
          }
        });
    },
    saveChangePrev() {
      if (this.listCalendar.length == 0) {
        return;
      }
      this.$bvModal.show("modal-save-change-counter");
    },
    async saveChange() {
      this.showSpinnerSend = true;
      let arraySchedule = [];

      let arraySend = this.listCalendar.filter((currentValue) => {
        return currentValue.request;
      });
      arraySend.forEach((element) => {
        let json = {
          StartDate: this.$moment(element.StartDate).format(
            this.formatDateSchedule
          ),
          EndDate: this.$moment(element.EndDate).format(
            this.formatDateSchedule
          ),
          StateClassId: parseInt(Constants.CALENDAR_STATUS.CONFIRM.VALUE),
          IsNew: element.isNew,
          NoRecurrent:
            element.noRecurrent === undefined || element.noRecurrent === false
              ? false
              : true,
        };
        arraySchedule.push(json);
      });
      let jsonData = {
        ScheduleCounter: {
          id: this.GroupScheduleCounterProposalId,
          groupScheduleProposalId: this.scheduleProposalId,
        },
        ScheduleCounterDetail: arraySchedule,
        UserMail: this.$store.state.user.email,
      };

      convertTimeCalendarEvents(
        jsonData.ScheduleCounterDetail,
        this.$store.state.user.timeZoneName,
        this.$moment
      );
      if (this.GroupScheduleCounterProposalId != 0) {
        let flagContinue = await this.validateScheduleCounterProposal(
          this.GroupScheduleCounterProposalId
        );
        if (!flagContinue) {
          return;
        }
      }
      baseInstanceAxios
        .post(
          `${this.apiURL}/resources/GroupScheduleCounterProposal/ValidateSaveEditionScheduleCounterByTeacher`,
          jsonData
        )
        .then((response) => {
          this.showSpinnerSend = false;
          this.showLoadingCalendar = false;
          if (response.data != null) {
            if (
              response.data.valueDecimal == 0 &&
              response.data.return == false
            ) {
              this.$bvModal.show("modal-validate-cross-teacher-navs");
              this.$bvModal.hide("modal-save-change-counter");
            } else {
              if (response.data.valueDecimal > 0) {
                this.message = this.$t("reusables.student-edited-schedule-14", {
                  NRO: response.data.valueDecimal.toString(),
                });
                this.$bvModal.show(
                  "modal-validate-save-change-counter-navs-send"
                );
              } else {
                this.saveChangeConfirm();
              }
            }
          }
        })
        .catch((error) => {
          this.message = this.$t("error.error-saving-changes");
          this.$bvToast.show("toast-equis-modal-calendar-class-teacher-navs");
          this.showSpinnerSend = false;
        });
    },
    async saveChangeConfirm() {
      this.showLoadingCalendar = true;
      this.$bvModal.hide("modal-validate-save-change-counter-navs-send");
      this.showSpinnerSend = true;
      let arraySchedule = [];

      let arraySend = this.listCalendar.filter((currentValue) => {
        return currentValue.request;
      });
      arraySend.forEach((element) => {
        let json = {
          StartDate: this.$moment(element.StartDate).format(
            this.formatDateSchedule
          ),
          EndDate: this.$moment(element.EndDate).format(
            this.formatDateSchedule
          ),
          StateClassId: parseInt(Constants.CALENDAR_STATUS.CONFIRM.VALUE),
          IsNew: element.isNew,
          NoRecurrent:
            element.noRecurrent === undefined || element.noRecurrent === false
              ? false
              : true,
        };
        arraySchedule.push(json);
      });
      let jsonData = {
        ScheduleCounter: {
          id: this.GroupScheduleCounterProposalId,
          groupScheduleProposalId: this.scheduleProposalId,
        },
        ScheduleCounterDetail: arraySchedule,
        UserMail: this.$store.state.user.email,
      };

      convertTimeCalendarEvents(
        jsonData.ScheduleCounterDetail,
        this.$store.state.user.timeZoneName,
        this.$moment
      );
      if (this.GroupScheduleCounterProposalId != 0) {
        let flagContinue = await this.validateScheduleCounterProposal(
          this.GroupScheduleCounterProposalId
        );
        if (!flagContinue) {
          return;
        }
      }
      baseInstanceAxios
        .post(
          `${this.apiURL}/resources/GroupScheduleCounterProposal/SaveEditionScheduleCounterByTeacher`,
          jsonData
        )
        .then((response) => {
          let value = response.data.value;
          this.showSpinnerAccept = false;
          if (value == -3) {
            this.message =
              "Was found conflicts with your current availability.";
            this.$bvToast.show("toast-equis-modal-request-class-nav");
            this.showSpinnerSend = false;
          } else if (value == -2 || value == 0) {
            this.message =
              "The student has deleted or modified the schedule change request. Please check again in a few moments.";
            this.$bvToast.show("toast-equis-modal-request-class-nav");
            this.showSpinnerSend = false;
          } else if (value > 0) {
            this.message = this.$t("valid.changes-saved-correctly");
            //this.$bvToast.show("toast-check-modal-calendar-class-navs");
            this.showSpinnerSend = false;
            this.$bvModal.hide("modal-save-change-counter");
            this.$bvModal.show("modal-save-change-counter-send");
            this.showLoadingCalendar = true;
            this.reply();
          }
        })
        .catch((error) => {
          this.message = this.$t("error.error-saving-changes");
          this.$bvToast.show("toast-equis-modal-calendar-class-teacher-navs");
          this.showSpinnerSend = false;
        });
    },
    async validateScheduleCounterProposal(groupScheduleCounterProposalId) {
      let flagContinue = false;
      let flagType = false; //parametro para validar la solicitud y no la propuesta o contrapropuesta
      let params = { groupScheduleCounterProposalId, flagType };

      await baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupScheduleCounterProposal/ValidateScheduleCounterProposalStudentByActive`,
          { params }
        )
        .then((response) => {
          flagContinue = response.data.return;
          if (!response.data.return) {
            let entity = response.data.entity;

            if (entity.flagProposalAcepted) {
              this.messageValidate = this.$t(
                "reusables.student-edited-schedule-11"
              ); //GH => Cambiar
              this.typeResponseEvent = 1;
            } else {
              let objectStatus =
                Constants.STATUS_VALIDATION_COUNTER_PROPOSAL[entity.typeResult];
              if (objectStatus)
                this.messageValidate =
                  this.lang == "es" ? objectStatus.ES : objectStatus.EN;

              if (!entity.flagCount) {
                this.typeResponseEvent = 1;
              }
            }
            this.$bvModal.show("modal-conflict-validate");
          }
        });
      return flagContinue;
    },
    handleDateSelect(selectInfo) {
      this.messageAddClass = "";
      let now = new Date();
      let expirationDate = new Date(this.groupsPlan.expirationDate);
      let startRange = new Date(this.calendarOptions.validRange.start);
      let endRange = new Date(this.calendarOptions.validRange.end);

      if (selectInfo.start < now) {
        this.messageAddClass = this.$t("reusables.student-edited-schedule-12");
        this.$bvModal.show("modal-validate-register-class-teacher-navs");
        return;
      } else if (selectInfo.start < startRange || selectInfo.end > endRange) {
        this.messageAddClass = this.messageAddClass = this.$t(
          "reusables.student-edited-schedule-13"
        );
        this.$bvModal.show("modal-validate-register-class-teacher-navs");
        return;
      } else if (selectInfo.start > expirationDate) {
        this.messageAddClass = this.messageAddClass = this.$t(
          "reusables.student-edited-schedule-13"
        );
        this.$bvModal.show("modal-validate-register-class-teacher-navs");
        return;
      } else {
        this.eventCreated = selectInfo;
        if (this.flagPlanTest) {
          this.$bvModal.show("modal-add-event-teacher-navs");
        } else {
          this.$bvModal.show("modal-add-class-teacher-navs");
        }
      }
    },
    handleEvents(events) {
      let newEvents = events.event;
      let oldEvent = events.oldEvent;

      let fechaInicio = newEvents.startStr;
      let fechaFin = newEvents.endStr;

      let eventCurrent = this.calendarOptions.events.find(function (e) {
        return (
          new Date(e.start).getTime() ==
            new Date(oldEvent.startStr).getTime() &&
          new Date(e.end).getTime() == new Date(oldEvent.endStr).getTime() &&
          e.request === true
        );
      });
      let noRecurrent = eventCurrent.noRecurrent;
      let dateSelectStart = new Date(fechaInicio);
      let dateSelectEnd = new Date(fechaFin);
      let dateEnd = null;

      let dateAfter = new Date(
        dateSelectStart.setMinutes(
          dateSelectStart.getMinutes() + this.maximoHorasCalendario * 60
        )
      );
      if (dateSelectEnd.getTime() < dateAfter.getTime()) {
        dateEnd = dateSelectEnd;
      } else {
        dateEnd = dateAfter;
      }

      if (noRecurrent) {
        this.listCalendar = this.listCalendar.filter(function (e) {
          return (
            new Date(e.StartDate).getTime() !==
              new Date(oldEvent.startStr).getTime() &&
            new Date(e.EndDate).getTime() !==
              new Date(oldEvent.endStr).getTime()
          );
        });

        this.calendarOptions.events = this.calendarOptions.events.filter(
          function (e) {
            return (
              new Date(e.start).getTime() !==
                new Date(oldEvent.startStr).getTime() &&
              new Date(e.end).getTime() !== new Date(oldEvent.endStr).getTime()
            );
          }
        );
      } else {
        const eventDayOfWeek = new Date(oldEvent.startStr).getDay();
        const eventTimeStart = oldEvent.startStr.slice(11, 16);
        const eventTimeEnd = oldEvent.endStr.slice(11, 16);
        const eventDate = new Date(oldEvent.startStr);
        this.arrayCalendarChange = this.arrayCalendarChange.filter((e) => {
          const eventStartDate = new Date(e.StartDate);
          return !(
            eventStartDate.getDay() === eventDayOfWeek &&
            e.StartDate.slice(11, 16) === eventTimeStart &&
            e.EndDate.slice(11, 16) === eventTimeEnd &&
            e.noRecurrent === false &&
            e.request === true &&
            eventStartDate >= eventDate
          );
        });

        this.listCalendar = this.listCalendar.filter((e) => {
          const eventStartDate = new Date(e.StartDate);
          return !(
            eventStartDate.getDay() === eventDayOfWeek &&
            e.StartDate.slice(11, 16) === eventTimeStart &&
            e.EndDate.slice(11, 16) === eventTimeEnd &&
            e.noRecurrent === false &&
            e.request === true &&
            eventStartDate >= eventDate
          );
        });
        this.calendarOptions.events = this.calendarOptions.events.filter(
          (e) => {
            const eventStartDate = new Date(e.start);
            return !(
              eventStartDate.getDay() === eventDayOfWeek &&
              e.start.slice(11, 16) === eventTimeStart &&
              e.end.slice(11, 16) === eventTimeEnd &&
              e.noRecurrent === false &&
              e.request === true &&
              eventStartDate >= eventDate
            );
          }
        );

        // eliminar el anterior
        this.listCalendar = this.listCalendar.filter(function (e) {
          return (
            new Date(e.StartDate).getTime() !==
              new Date(oldEvent.startStr).getTime() &&
            new Date(e.EndDate).getTime() !==
              new Date(oldEvent.endStr).getTime()
          );
        });

        this.calendarOptions.events = this.calendarOptions.events.filter(
          function (e) {
            return (
              new Date(e.start).getTime() !==
                new Date(oldEvent.startStr).getTime() &&
              new Date(e.end).getTime() !== new Date(oldEvent.endStr).getTime()
            );
          }
        );
      }
      events.event.remove();

      let _eventItemMerge = ValidarMergeHorariosByRecurrent(
        this.calendarOptions.events,
        fechaInicio,
        fechaFin,
        this.$moment,
        noRecurrent
      );
      let p_idEvent = createEventId();
      if (Object.keys(_eventItemMerge).length !== 0) {
        this.arrayCalendarChange.forEach((obj, i) => {
          if (obj.id == _eventItemMerge.idx) {
            obj.StartDate = this.$moment(_eventItemMerge.start).format(
              this.formatDateSchedule
            );
            obj.EndDate = this.$moment(_eventItemMerge.end).format(
              this.formatDateSchedule
            );
          }
        });

        this.listCalendar.forEach((obj, i) => {
          if (
            obj.idx ==
            (_eventItemMerge.idx == 0
              ? _eventItemMerge.id
              : parseInt(_eventItemMerge.idx, 10))
          ) {
            obj.StartDate = this.$moment(_eventItemMerge.start).format(
              this.formatDateSchedule
            );
            obj.EndDate = this.$moment(_eventItemMerge.end).format(
              this.formatDateSchedule
            );
          }
        });
      } else {
        let idx = this.obtenerCalendarId();

        let data2 = {
          id: idx,
          StartDate: this.$moment(fechaInicio).format(this.formatDateSchedule),
          EndDate: this.$moment(dateEnd).format(this.formatDateSchedule),
          StateClass: Constants.CALENDAR_STATUS.CONFIRM.VALUE,
          request: true,
          editable: true,
          noRecurrent: noRecurrent,
          isNew: true,
          flagPlantTest: false,
        };

        this.listCalendar.push(data2);

        this.calendarOptions.events.push({
          idx: idx,
          id: p_idEvent, //createEventId(),
          start: this.$moment(fechaInicio).format(this.formatDateSchedule),
          end: this.$moment(dateEnd).format(this.formatDateSchedule),
          title: this.dataStudent.strFullName,
          editable: true,
          request: true,
          color: noRecurrent
            ? Constants.CALENDAR_STATUS_ADDITIONAL_COLOR.NORECURRENT
            : Constants.CALENDAR_STATUS.CONFIRM.COLOR,
          noRecurrent: noRecurrent,
          isNew: true,
        });
      }

      if (!noRecurrent) {
        let replicatedStartDate = new Date(fechaInicio);
        const expirationDate = new Date(this.groupsPlan.expirationDate);

        while (replicatedStartDate < expirationDate) {
          replicatedStartDate.setDate(replicatedStartDate.getDate() + 7);
          dateEnd.setDate(dateEnd.getDate() + 7);

          let _eventItemMerge = ValidarMergeHorariosByRecurrent(
            this.calendarOptions.events,
            replicatedStartDate.toISOString(),
            dateEnd.toISOString(),
            this.$moment,
            false
          );

          if (Object.keys(_eventItemMerge).length !== 0) {
            this.JoinEvent(_eventItemMerge);
          } else {
            let newIdx = this.obtenerCalendarId();
            this.AddNewEvent(
              newIdx,
              p_idEvent,
              replicatedStartDate,
              dateEnd,
              false
            );
          }
        }
      }
    },
    saveEvent() {
      let fechaInicio = this.eventCreated.startStr;
      let fechaFin = this.eventCreated.endStr;

      this.editHourTotal += this.hoursEdit;

      let idx = this.obtenerCalendarId();

      let dateSelectStart = new Date(fechaInicio);
      let dateSelectEnd = new Date(fechaFin);
      let dateEnd = null;

      if (this.flagPlanTest) {
        let dateAfter = new Date(
          dateSelectStart.setMinutes(
            dateSelectStart.getMinutes() + this.maximoHorasCalendario * 60
          )
        );
        dateEnd = dateAfter;
      } else {
        let dateAfter = new Date(
          dateSelectStart.setMinutes(
            dateSelectStart.getMinutes() + this.maximoHorasCalendario * 60
          )
        );
        if (dateSelectEnd.getTime() < dateAfter.getTime()) {
          dateEnd = fechaFin;
        } else {
          dateEnd = dateAfter;
        }
      }

      let num = this.ObtenerRangoFecha(fechaInicio, dateEnd, this.listCalendar);
      if (num == 0) {
        let eventData;
        //let eventMerge = false;
        let _eventItemMerge = ValidarMergeHorarios(
          this.calendarOptions.events,
          fechaInicio,
          dateEnd,
          this.$moment
        );

        if (Object.keys(_eventItemMerge).length != 0) {
          //si hay merge

          this.arrayCalendarChange.forEach((obj, i) => {
            if (obj.id == _eventItemMerge.idx) {
              obj.StartDate = this.$moment(_eventItemMerge.start).format(
                this.formatDateSchedule
              );
              obj.EndDate = this.$moment(_eventItemMerge.end).format(
                this.formatDateSchedule
              );
            }
          });
          this.listCalendar.forEach((obj, i) => {
            if (
              obj.idx ==
              (_eventItemMerge.idx == 0
                ? _eventItemMerge.id
                : parseInt(_eventItemMerge.idx, 10))
            ) {
              obj.StartDate = this.$moment(_eventItemMerge.start).format(
                this.formatDateSchedule
              );
              obj.EndDate = this.$moment(_eventItemMerge.end).format(
                this.formatDateSchedule
              );
            }
          });
        } else {
          eventData = {
            id: idx,
            StartDate: this.$moment(fechaInicio).format(
              this.formatDateSchedule
            ),
            EndDate: this.$moment(dateEnd).format(this.formatDateSchedule),
            StateClass: Constants.CALENDAR_STATUS.CONFIRM.VALUE,
            request: true,
            editable: true,
          };
          this.arrayCalendarChange.push(eventData);
          this.listCalendar.push(eventData);

          this.calendarOptions.events.push({
            idx: idx,
            id: createEventId(),
            description: "",
            start: this.$moment(fechaInicio).format(this.formatDateSchedule),
            end: this.$moment(dateEnd).format(this.formatDateSchedule),
            title:
              this.dataStudent.strFullName +
              " | " +
              this.$t("reusables.test-class"),
            request: true,
            editable: true,
            isInList: false,
          });
        }

        this.disabledDate = false;

        this.getDateMinMax(new Date());
        this.$bvModal.hide("modal-add-event-teacher-navs");
      } else {
        this.message = `${this.$t(
          "modals.modalViewSchedule.maximoHorasCalendario.1"
        )} ${this.maximoHorasCalendario * 60} ${this.$t(
          "modals.modalViewSchedule.maximoHorasCalendario.2"
        )} `;
        this.$bvToast.show("toast-equis-modal-calendar-class-teacher-navs");
      }

      this.$bvModal.hide("modal-add-event-teacher-navs");
    },
    SaveClassRegister() {
      this.$v.classRegister.$touch();
      if (this.$v.classRegister.$invalid) {
        return;
      } else {
        let fechaInicio = this.eventCreated.startStr;
        let fechaFin = this.eventCreated.endStr;

        let idx = this.obtenerCalendarId();
        let _id = createEventId();

        let dateSelectStart = new Date(fechaInicio);
        let dateSelectEnd = new Date(fechaFin);
        let dateEnd;
        let noRecurrent = this.classRegister.typeClass === "true";

        let dateAfter = new Date(dateSelectStart);
        dateAfter.setMinutes(
          dateAfter.getMinutes() + this.maximoHorasCalendario * 60
        );
        dateEnd =
          dateSelectEnd.getTime() < dateAfter.getTime()
            ? dateSelectEnd
            : dateAfter;

        let num = this.ObtenerRangoFecha(
          fechaInicio,
          dateEnd.toISOString(),
          this.listCalendar
        );
        if (num === 0) {
          let replicatedStartDate = new Date(fechaInicio);
          const expirationDate = new Date(this.groupsPlan.expirationDate);

          let _eventItemMerge = ValidarMergeHorariosByRecurrent(
            this.calendarOptions.events,
            replicatedStartDate.toISOString(),
            dateEnd.toISOString(),
            this.$moment,
            noRecurrent
          );

          if (Object.keys(_eventItemMerge).length !== 0) {
            this.JoinEvent(_eventItemMerge);
          } else {
            this.AddNewEvent(
              idx,
              _id,
              replicatedStartDate,
              dateEnd,
              noRecurrent
            );
          }

          if (noRecurrent) {
            this.FinishSaved();
            return;
          }
          while (replicatedStartDate < expirationDate) {
            replicatedStartDate.setDate(replicatedStartDate.getDate() + 7);
            dateEnd.setDate(dateEnd.getDate() + 7);

            let _eventItemMerge = ValidarMergeHorariosByRecurrent(
              this.calendarOptions.events,
              replicatedStartDate.toISOString(),
              dateEnd.toISOString(),
              this.$moment,
              false
            );

            if (Object.keys(_eventItemMerge).length !== 0) {
              this.JoinEvent(_eventItemMerge);
            } else {
              let newIdx = this.obtenerCalendarId();
              this.AddNewEvent(
                newIdx,
                _id,
                replicatedStartDate,
                dateEnd,
                false
              );
            }
          }

          this.FinishSaved();
        } else {
          this.message = `${this.$t(
            "modals.modalViewSchedule.maximoHorasCalendario.1"
          )} ${this.maximoHorasCalendario * 60} ${this.$t(
            "modals.modalViewSchedule.maximoHorasCalendario.2"
          )}`;
          this.$bvToast.show("toast-equis-modal-calendar-class-teacher-navs");
        }
      }
    },
    JoinEvent(eventItemMerge) {
      this.arrayCalendarChange.forEach((obj) => {
        if (obj.id === eventItemMerge.idx) {
          obj.StartDate = this.$moment(eventItemMerge.start).format(
            this.formatDateSchedule
          );
          obj.EndDate = this.$moment(eventItemMerge.end).format(
            this.formatDateSchedule
          );
        }
      });

      this.listCalendar.forEach((obj) => {
        if (
          obj.idx ===
          (eventItemMerge.idx === 0
            ? eventItemMerge.id
            : parseInt(eventItemMerge.idx, 10))
        ) {
          obj.StartDate = this.$moment(eventItemMerge.start).format(
            this.formatDateSchedule
          );
          obj.EndDate = this.$moment(eventItemMerge.end).format(
            this.formatDateSchedule
          );
        }
      });
    },

    AddNewEvent(idx, _id, start, end, noRecurrent) {
      let eventData = {
        id: idx,
        StartDate: this.$moment(start).format(this.formatDateSchedule),
        EndDate: this.$moment(end).format(this.formatDateSchedule),
        StateClass: Constants.CALENDAR_STATUS.CONFIRM.VALUE,
        request: true,
        editable: true,
        noRecurrent: noRecurrent,
        isNew: true,
      };

      this.arrayCalendarChange.push(eventData);
      this.listCalendar.push(eventData);

      this.calendarOptions.events.push({
        idx: idx,
        id: _id,
        description: "",
        start: this.$moment(start).format(this.formatDateSchedule),
        end: this.$moment(end).format(this.formatDateSchedule),
        title: this.dataStudent.strFullName,
        editable: true,
        request: true,
        color: noRecurrent
          ? Constants.CALENDAR_STATUS_ADDITIONAL_COLOR.NORECURRENT
          : Constants.CALENDAR_STATUS.CONFIRM.COLOR,
        noRecurrent: noRecurrent,
        isNew: true,
      });
    },
    FinishSaved() {
      this.disabledDate = false;
      this.getDateMinMax(new Date());
      this.$bvModal.hide("modal-add-class-teacher-navs");

      if (this.classRegister.typeClass === "true") {
        this.classRegister.idx = createEventId();
        this.listClassRegister.push(this.classRegister);
      }

      this.classRegister = {
        id: "",
        typeClass: null,
        timeClass: null,
        startDate: null,
        endDate: null,
        noRecurrent: false,
        isNew: false,
      };

      this.$bvModal.hide("modal-add-class-teacher-navs");
      this.$v.classRegister.$reset();
    },
    obtenerCalendarId() {
      let idx = 0;
      let dataTmp = this.listCalendar;

      let ultId =
        dataTmp.length == 0 ? 1 * -1000 : dataTmp[dataTmp.length - 1].id;
      ultId = ultId == null ? 0 : ultId;
      idx = ultId > 0 ? dataTmp.length * -1000 : ultId - 1000;

      return idx;
    },
    ObtenerRangoFecha(StartDate, EndDate, listCalendar) {
      var result = listCalendar.filter((e) => {
        return (
          (!(
            new Date(StartDate).getTime() == new Date(e.StartDate).getTime()
          ) &&
            new Date(StartDate).getTime() <= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.StartDate).getTime() &&
            new Date(StartDate).getTime() < new Date(e.EndDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() <= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() > new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() == new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() == new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.EndDate).getTime())
        );
      });
      return result.length;
    },
    removeEvent(event) {
      if (this.flagPlanTest) {
        this.removeEventPlanTest(event);
      } else {
        let eventCurrent = this.calendarOptions.events.find((currentValue) => {
          return parseInt(currentValue.id) == event.id && currentValue.isNew;
        });
        this.eventDelete = event;
        if (eventCurrent == undefined) {
          this.GetScheduleByDelete(event);
        } else {
          this.classDelete.isNew = true;
          this.SaveClassDeleteByNew(event, eventCurrent.noRecurrent);
          this.listClassRegister = this.listClassRegister.filter(
            (currentValue) => {
              return (
                currentValue.idx == undefined ||
                !(parseInt(currentValue.idx) == event.id && currentValue.isNew)
              );
            }
          );
        }
      }
    },
    removeEventPlanTest(event) {
      this.arrayCalendarChange = this.arrayCalendarChange.filter(function (e) {
        return (
          new Date(e.StartDate).getTime() !=
            new Date(event.startStr).getTime() &&
          new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
        );
      });
      this.listCalendar = this.listCalendar.filter(function (e) {
        return (
          new Date(e.StartDate).getTime() !=
            new Date(event.startStr).getTime() &&
          new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
        );
      });
      this.calendarOptions.events = this.calendarOptions.events.filter(
        function (e) {
          return (
            new Date(e.start).getTime() != new Date(event.startStr).getTime() &&
            new Date(e.end).getTime() != new Date(event.endStr).getTime()
          );
        }
      );

      if (this.arrayCalendarChange.length > 0) {
        this.disabledDate = false;
        this.getDateMinMax(new Date());
      } else {
        this.disabledDate = true;
        this.SelectBeginningDate = new Date();
      }

      event.remove();
    },
    SaveClassDeleteByNew(event, noRecurrent) {
      this.classDelete.id = event.id;
      this.infoEventoDelete.startDate = event.start;
      this.infoEventoDelete.endDate = event.end;
      this.idValueSelectEventSelectedTimeClassDelete(event);
      if (!noRecurrent) {
        this.$bvModal.show("delete-recurring-class-teacher-navs");
      } else {
        this.$bvModal.show("modal-delete-class-teacher-navs");
      }
    },
    SaveClassDeleteByNewConfirm(event, noRecurrent) {
      if (noRecurrent) {
        this.arrayCalendarChange = this.arrayCalendarChange.filter(function (
          e
        ) {
          return (
            new Date(e.StartDate).getTime() !=
              new Date(event.startStr).getTime() &&
            new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
          );
        });
        this.listCalendar = this.listCalendar.filter(function (e) {
          return (
            new Date(e.StartDate).getTime() !=
              new Date(event.startStr).getTime() &&
            new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
          );
        });
        this.calendarOptions.events = this.calendarOptions.events.filter(
          function (e) {
            return (
              new Date(e.start).getTime() !=
                new Date(event.startStr).getTime() &&
              new Date(e.end).getTime() != new Date(event.endStr).getTime()
            );
          }
        );
      } else {
        const eventDayOfWeek = new Date(event.startStr).getDay();
        const eventTimeStart = event.startStr.slice(11, 16);
        const eventTimeEnd = event.endStr.slice(11, 16);
        const eventDate = new Date(event.startStr);

        this.arrayCalendarChange = this.arrayCalendarChange.filter((e) => {
          const eventStartDate = new Date(e.StartDate);
          return !(
            eventStartDate.getDay() === eventDayOfWeek &&
            e.StartDate.slice(11, 16) === eventTimeStart &&
            e.EndDate.slice(11, 16) === eventTimeEnd &&
            e.noRecurrent === false &&
            e.request === true &&
            eventStartDate >= eventDate
          );
        });

        this.listCalendar = this.listCalendar.filter((e) => {
          const eventStartDate = new Date(e.StartDate);
          return !(
            eventStartDate.getDay() === eventDayOfWeek &&
            e.StartDate.slice(11, 16) === eventTimeStart &&
            e.EndDate.slice(11, 16) === eventTimeEnd &&
            e.noRecurrent === false &&
            e.request === true &&
            eventStartDate >= eventDate
          );
        });
        this.calendarOptions.events = this.calendarOptions.events.filter(
          (e) => {
            const eventStartDate = new Date(e.start);
            return !(
              eventStartDate.getDay() === eventDayOfWeek &&
              e.start.slice(11, 16) === eventTimeStart &&
              e.end.slice(11, 16) === eventTimeEnd &&
              e.noRecurrent === false &&
              e.request === true &&
              eventStartDate >= eventDate
            );
          }
        );
        // eliminar evento actual
        this.arrayCalendarChange = this.arrayCalendarChange.filter(function (
          e
        ) {
          if (e.noRecurrent === true) {
            return true;
          }
          return (
            new Date(e.StartDate).getTime() !=
              new Date(event.startStr).getTime() &&
            new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
          );
        });
        this.listCalendar = this.listCalendar.filter(function (e) {
          if (e.noRecurrent === true) {
            return true;
          }
          return (
            new Date(e.StartDate).getTime() !=
              new Date(event.startStr).getTime() &&
            new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
          );
        });
        this.calendarOptions.events = this.calendarOptions.events.filter(
          function (e) {
            if (e.noRecurrent === true) {
              return true;
            }
            return (
              new Date(e.start).getTime() !=
                new Date(event.startStr).getTime() &&
              new Date(e.end).getTime() != new Date(event.endStr).getTime()
            );
          }
        );
      }

      if (this.arrayCalendarChange.length > 0) {
        this.disabledDate = false;
        this.getDateMinMax(new Date());
      } else {
        this.disabledDate = true;
        this.SelectBeginningDate = new Date();
      }
      event.remove();
      this.classDelete = {
        id: 0,
        typeClass: null,
        timeClass: null,
        startDate: null,
        endDate: null,
        isDelete: false,
      };
      this.classDeleteTimeClass = " ";

      this.$bvModal.hide("delete-recurring-class-teacher-navs");
      this.$v.classDelete.$reset();
    },
    GetScheduleByDelete(event) {
      this.classDeleteTimeClass = " ";
      var startDate = convertTimeToUTC(
        event.start,
        this.$store.state.user.timeZoneName,
        this.$moment
      );
      var endDate = convertTimeToUTC(
        event.end,
        this.$store.state.user.timeZoneName,
        this.$moment
      );

      this.infoEventoDelete.startDate = event.start;
      this.infoEventoDelete.endDate = event.end;
      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/PersonsTeachers/GetScheduleByDelete?startDate=${startDate}&endDate=${endDate}&groupPlanId=${this.groupsPlan.id}`
        )

        .then((response) => {
          if (response.data != null) {
            if (response.data.value == 0) {
              this.$bvModal.show(
                "modal-delete-class-without-result-teacher-navs"
              );
            } else {
              this.classDelete.id = response.data.value;
              this.idValueSelectEventSelectedTimeClassDelete(event);

              if (!response.data.return) {
                this.$bvModal.show("delete-recurring-class-teacher-navs");
              } else {
                this.$bvModal.show("modal-delete-class-teacher-navs");
              }
            }
          }
        });
    },
    SaveClassDelete() {
      this.$v.classDelete.$touch();
      if (this.$v.classDelete.$invalid) {
        return;
      } else {
        const event = this.eventDelete;
        if (
          this.classDelete.isNew != undefined &&
          this.classDelete.isNew == true
        ) {
          this.SaveClassDeleteByNewConfirm(
            event,
            this.classDelete.typeClass === "false" ? false : true
          );
          this.listClassRegister = this.listClassRegister.filter(
            (currentValue) => {
              return (
                currentValue.idx == undefined ||
                !(parseInt(currentValue.idx) == event.id && currentValue.isNew)
              );
            }
          );
        } else {
          if (
            this.eventDelete != null &&
            this.classDelete.typeClass === "false"
          ) {
            const eventDayOfWeek = new Date(event.startStr).getDay();
            const eventTimeStart = event.startStr.slice(11, 16);
            const eventTimeEnd = event.endStr.slice(11, 16);
            const eventDate = new Date(event.startStr);
            this.arrayCalendarChange = this.arrayCalendarChange.filter((e) => {
              const eventStartDate = new Date(e.StartDate);
              return !(
                eventStartDate.getDay() === eventDayOfWeek &&
                e.StartDate.slice(11, 16) === eventTimeStart &&
                e.EndDate.slice(11, 16) === eventTimeEnd &&
                e.noRecurrent === false &&
                e.request === true &&
                eventStartDate >= eventDate
              );
            });
            this.listCalendar = this.listCalendar.filter((e) => {
              const eventStartDate = new Date(e.StartDate);
              return !(
                eventStartDate.getDay() === eventDayOfWeek &&
                e.StartDate.slice(11, 16) === eventTimeStart &&
                e.EndDate.slice(11, 16) === eventTimeEnd &&
                e.noRecurrent === false &&
                e.request === true &&
                eventStartDate >= eventDate
              );
            });
            this.calendarOptions.events = this.calendarOptions.events.filter(
              (e) => {
                const eventStartDate = new Date(e.start);
                return !(
                  eventStartDate.getDay() === eventDayOfWeek &&
                  e.start.slice(11, 16) === eventTimeStart &&
                  e.end.slice(11, 16) === eventTimeEnd &&
                  e.noRecurrent === false &&
                  e.request === true &&
                  eventStartDate >= eventDate
                );
              }
            );
            if (this.arrayCalendarChange.length > 0) {
              this.getDateMinMax(new Date());
            } else {
              this.SelectBeginningDate = new Date();
            }

            this.eventDelete = null;
          } else {
            this.listClassDelete.push(this.classDelete);
            this.arrayCalendarChange = this.arrayCalendarChange.filter(
              function (e) {
                return (
                  new Date(e.StartDate).getTime() !=
                    new Date(event.startStr).getTime() &&
                  new Date(e.EndDate).getTime() !=
                    new Date(event.endStr).getTime()
                );
              }
            );
            this.listCalendar = this.listCalendar.filter(function (e) {
              return (
                new Date(e.StartDate).getTime() !=
                  new Date(event.startStr).getTime() &&
                new Date(e.EndDate).getTime() !=
                  new Date(event.endStr).getTime()
              );
            });
            this.calendarOptions.events = this.calendarOptions.events.filter(
              function (e) {
                return (
                  new Date(e.start).getTime() !=
                    new Date(event.startStr).getTime() &&
                  new Date(e.end).getTime() != new Date(event.endStr).getTime()
                );
              }
            );
          }
        }

        event.remove();
        this.classDelete = {
          id: 0,
          typeClass: null,
          timeClass: null,
          startDate: null,
          endDate: null,
          isDelete: false,
        };
        this.classDeleteTimeClass = " ";
        this.$bvModal.hide("delete-recurring-class-teacher-navs");
        this.$v.classDelete.$reset();
      }
    },
    SaveClassDeleteNoRecurrent() {
      var event = this.eventDelete;
      this.arrayCalendarChange = this.arrayCalendarChange.filter(function (e) {
        return (
          new Date(e.StartDate).getTime() !=
            new Date(event.startStr).getTime() &&
          new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
        );
      });
      this.listCalendar = this.listCalendar.filter(function (e) {
        return (
          new Date(e.StartDate).getTime() !=
            new Date(event.startStr).getTime() &&
          new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
        );
      });
      this.calendarOptions.events = this.calendarOptions.events.filter(
        function (e) {
          return (
            new Date(e.start).getTime() != new Date(event.startStr).getTime() &&
            new Date(e.end).getTime() != new Date(event.endStr).getTime()
          );
        }
      );

      if (this.arrayCalendarChange.length > 0) {
        this.getDateMinMax(new Date());
      } else {
        this.SelectBeginningDate = new Date();
      }
      this.listClassDelete.push(this.classDelete);
      event.remove();
      this.eventDelete = null;
      this.classDelete = {
        id: 0,
        typeClass: null,
        timeClass: null,
        startDate: null,
        endDate: null,
        isDelete: false,
      };
      this.$bvModal.hide("modal-delete-class-teacher-navs");
    },
    idValueSelectEventSelectedTime(event) {
      this.selectedTime = event;
    },
    handleSelecAllow(selectInfo) {
      if (this.flagPlanTest) {
        let dateCurrent = new Date();
        let newDateCurrent = new Date(
          dateCurrent.setMinutes(
            dateCurrent.getMinutes() - this.maximoHorasCalendario * 60
          )
        );
        let dataAfter = this.$moment(newDateCurrent).add(
          this.daysMaxSchedule - 1,
          "days"
        );
        let dataStar = this.$moment(selectInfo.start);
        let valueBefore = this.$moment(dataStar).isSameOrBefore(dataAfter);
        let valueAfter = this.$moment(new Date(selectInfo.start)).isAfter(
          new Date()
        );
        let dateSelectStart = new Date(selectInfo.start);
        let endAfter = selectInfo.end;
        let arraySend = this.listCalendar.filter((currentValue) => {
          return currentValue.request;
        });
        if (arraySend.length == 1) {
          return false;
        }

        let dateAfter = new Date(
          dateSelectStart.setMinutes(
            dateSelectStart.getMinutes() + this.maximoHorasCalendario * 60
          )
        );

        if (
          endAfter.getTime() <= dateAfter.getTime() &&
          valueBefore &&
          valueAfter
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        let num = this.ObtenerRangoFecha(
          selectInfo.startStr,
          selectInfo.endStr,
          this.listCalendar
        );

        if (num > 0) {
          return false;
        }

        let dateSelectStart = new Date(selectInfo.start);
        let endAfter = selectInfo.end;

        let dateAfter = new Date(
          dateSelectStart.setHours(dateSelectStart.getHours() + 6)
        );

        if (endAfter.getTime() <= dateAfter.getTime()) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
};
</script>